export const DS_FORMS_BASE_URL = '/v1/dsform/projects/';
